import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Button from 'layout/atoms/Button/Button';
import TabsButton from 'layout/atoms/TabsButton/TabsButton';
import { openModal } from 'store/layoutSlice';
import Elements from '../Elements/Elements';
import Templates from '../Templates/Templates';
function ModelDimensions() {
    const dispatch = useDispatch();
    const { t } = useTranslation(['specification']);
    const [mode, setMode] = useState('elements');
    const tabs = [
        { id: 'elements', label: t('elements') },
        { id: 'templates', label: t('templates') },
    ];
    const toolbar = (React.createElement(React.Fragment, null,
        React.createElement(TabsButton, { size: "s", activeTab: mode, tabs: tabs, onClick: (id) => setMode(id) }),
        React.createElement(Button, { color: "primary", onClick: () => dispatch(openModal({ name: mode === 'elements' ? 'elementCreator' : 'templateCreator' })) }, t(mode === 'elements' ? 'add_element' : 'add_template'))));
    return mode === 'elements' ? React.createElement(Elements, { toolbar: toolbar }) : React.createElement(Templates, { toolbar: toolbar });
}
export default memo(ModelDimensions);
